import { createFileRoute, Outlet } from '@tanstack/react-router'

import { PromoLoginCard } from '@/pages/promotion/components/promo-login-card'
import { TabsLayoutNav } from '@/pages/promotion/components/tabs-layout-nav'

export const Route = createFileRoute('/_layout/promotion/august-2025/_tabs')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col gap-16 sm:gap-8">
      <TabsLayoutNav />
      <PromoLoginCard />
      <Outlet />
    </div>
  )
}
